export const SET_RPMPUMP = 'SET_RPMPUMP';
export const SET_SPEED = 'SET_SPEED';
